var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconFootballExample = function SvgIconFootballExample(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "".concat(props.prefix || "", "icon_football_example_svg__a")
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.334 0c.79 0 1.43.639 1.43 1.427v9.031l1.357-1.319a.95.95 0 0 1 1.334 0l2.271 2.274a.931.931 0 0 1 0 1.32l-9.018 8.999a.96.96 0 0 1-.667.268H7.759a.938.938 0 0 1-.947-.933v-2.35h-5.38a1.423 1.423 0 0 1-1.012-.41A1.414 1.414 0 0 1 0 17.302V1.427C-.003 1.047.147.683.416.415A1.423 1.423 0 0 1 1.431 0h11.903Zm3.411 11.123-8.082 8.045v.944h.947l8.082-8.045-.947-.944Zm-3.863-9.246H1.916l-.022 15.017h6.457l4.53-4.559V1.877Zm-9.084 5.69.12.006h4.928a.945.945 0 0 1 .846.938.945.945 0 0 1-.846.939H3.917a.948.948 0 0 1-.903-.438.941.941 0 0 1 .666-1.435l.118-.01Zm.129-3.282.12.006h5.65a.945.945 0 0 1 .845.938.945.945 0 0 1-.846.939h-5.65a.948.948 0 0 1-.903-.438.941.941 0 0 1 .666-1.435l.118-.01Z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "".concat(props.prefix || "", "icon_football_example_svg__b")
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.828 0v25.743H0V0h25.828Z"
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#".concat(props.prefix || "", "icon_football_example_svg__a)")
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#204193",
    d: "M0 0h20v22H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#".concat(props.prefix || "", "icon_football_example_svg__b)"),
    transform: "translate(-3.228 -2.145)"
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#00C06C",
    d: "M3.228 2.145h20v22h-20v-22z"
  })))));
};
export default SvgIconFootballExample;